import { UseFormRegister } from 'react-hook-form';
import { ConcentrationFormData } from 'interfaces/concentration';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import RadioInput from 'components/UI/RadioInput/RadioInput';

/**
 * @description Props for the AllowRapidComplete component
 * @typedef {Object} AllowRapidCompleteProps
 * @property {UseFormRegister<ConcentrationFormData>} register - The register function from react-hook-form
 * @property {boolean} canManage - Whether the user has permission to manage this setting
 */
type AllowRapidCompleteProps = {
  register: UseFormRegister<ConcentrationFormData>;
  canManage: boolean;
};

/**
 * @description Component that renders radio buttons for enabling/disabling rapid complete functionality.
 *
 * @SADtrace SAD-003-4.1, SAD-003-4.2, SAD-003-4.3
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {AllowRapidCompleteProps} props - Component props
 *
 * @returns {JSX.Element} Rendered component
 */
const AllowRapidComplete: FC<AllowRapidCompleteProps> = ({
  register,
  canManage,
}) => {
  const { t } = useTranslation();

  return (
    <div className="customRow pt-5">
      <div className="device-concentration-form__label  align-items-start">
        {t('device.rapid_complete')}
      </div>
      <div className="customRow ps-0 allow-rapid-radios">
        <RadioInput
          {...register('allow_rapid_complete')}
          value={'OFF'}
          id="allow_rapid_complete__off"
          disabled={!canManage}
          title={t('device.rapid_complete__off')}
          data-testid="allow_rapid_complete"
        />
        <RadioInput
          {...register('allow_rapid_complete')}
          value={'ON'}
          id="allow_rapid_complete__on"
          disabled={!canManage}
          title={t('device.rapid_complete__on')}
          data-testid="allow_rapid_complete"
        />
      </div>
    </div>
  );
};

export default AllowRapidComplete;
